<template>
  <div>
    <Head title="Regjistrimi i dërgesave"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/dergesat">Dërgesat</Link>
      <span class="text-indigo-400 font-medium">/</span> Regjistro
    </h1>
    <div class=" bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
<!--          <select-input v-model="form.business_id" :error="form.errors.business_id" class="pb-8 pr-6 w-full lg:w-1/4"-->
<!--                        label="Biznesi shitës"-->
<!--          >-->
<!--            <option v-for="business in businesses" :key="business.id" :value="business.id">{{ business.name }}</option>-->
<!--          </select-input>-->

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="form-label">Biznesi shitës</label>
            <Multiselect
              v-model="form.business_id"
              :options="filterBusinesses.options"
              :close-on-select="true"
              :searchable="true"
              :create-option="false"
              :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
            />
            <div v-if="form.errors.business_id" class="form-error">{{ form.errors.business_id }}</div>
          </div>


          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="form-label">Pika marrëse:</label>
            <select v-model="form.location_id" :error="form.errors.location_id"
                    class="form-select focus:ring-0 hover:border-indigo-500"
            >
              <option v-for="location in selectedLocations" :key="location.id" :value="location.id">{{
                  location.name
                }}
              </option>
            </select>
          </div>

          <text-input v-model="form.custom_id" :error="form.errors.custom_id" class="pb-8 pr-6 w-full lg:w-1/4"
                      label="ID e sistemit tuaj"
          />


        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full">Të dhënat e dërgesës</h3>
          <select-input v-model="form.package_size_id" :error="form.errors.package_size_id"
                        class="pb-8 pr-6 w-full lg:w-1/4" label="Madhësia e pakos"
          >
            <option v-for="packageSize in packageSizes" :key="packageSize.id" :value="packageSize.id">
              {{ packageSize.name }} {{ packageSize.description }}
            </option>
          </select-input>

          <select-input v-model="form.fragile" :error="form.errors.fragile" class="pb-8 pr-6 w-full lg:w-1/4"
                        label="A është pako fragjile(e dëmtueshme)"
          >
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <select-input v-model="form.openable" :error="form.errors.openable" class="pb-8 pr-6 w-full lg:w-1/4"
                        label="A mund të hapet pako"
          >
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <text-input v-model="form.quantity" :error="form.errors.quantity" class="pb-8 pr-6 w-full lg:w-1/4"
                      label="Sasia e produktit"
          />

          <text-input v-model="form.product_name" :error="form.errors.product_name" class="pb-8 pr-6 w-full lg:w-1/4"
                      label="Emri i produktit"
          />
<!--          <text-input v-model="form.product_description" :error="form.errors.product_description"-->
<!--                      class="pb-8 pr-6 w-full lg:w-1/4" label="Përshkrimi i produktit(opsionale)"-->
<!--          />-->
          <text-input v-model="form.product_price" :error="form.errors.product_price" :info="`Çmimi i produktit duhet të përfshijë çmimin e postës`" class="pb-8 pr-6 w-full lg:w-1/4"
                      label="Çmimi i produktit"
          />

          <text-input v-model="shipping_price" class="pb-8 pr-6 w-full lg:w-1/4" disabled label="Çmimi i postës"/>



          <div class="flex flex-wrap w-full">
            <select-input :disabled="!is_change_show" v-model="form.is_change" :error="form.errors.is_change" class="pb-8 pr-6 w-full lg:w-1/4"
                          label="A është ndërrim?"
            >
              <option :value="true">Po</option>
              <option :value="false">Jo</option>
            </select-input>

            <select-input :disabled="!is_cash_show" v-model="form.is_cash" :error="form.errors.is_cash" class="pb-8 pr-6 w-full lg:w-1/4"
                          label="A është kthim i mjeteve?"
            >
              <option :value="true">Po</option>
              <option :value="false">Jo</option>
            </select-input>

            <select-input v-if="has_product_show" v-model="form.has_product" :error="form.errors.has_product" class="pb-8 pr-6 w-full lg:w-1/4"
                          label="A ka produkt për t'u kthyer?"
            >
              <option :value="true">Po</option>
              <option :value="false">Jo</option>
            </select-input>

            <text-input v-if="has_product_show || this.form.is_change" v-model="form.return_id" :error="form.errors.return_id" class="pb-8 pr-6 w-full lg:w-1/4"
                        label="ID e dërgesës për kthim/ndërrim"
            />

          </div>
        </div>


        <hr>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full">Të dhënat e klientit</h3>
          <text-input v-model="form.name" :error="form.errors.name" maxlength="60" class="pb-8 pr-6 w-full lg:w-1/4"
                      label="Emri & Mbiemri"
          />

          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/4"
                      label="Telefoni"
          />
          <text-input v-model="form.second_phone" :error="form.errors.second_phone" class="pb-8 pr-6 w-full lg:w-1/4"
                      label="Telefoni (sekondar)"
          />

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="form-label">Shteti:</label>
            <select v-model="form.country_id" :error="form.errors.country_id"
                    class="form-select focus:ring-0 hover:border-indigo-500"
            >
              <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
            </select>
          </div>

<!--          <div class="pb-8 pr-6 w-full lg:w-1/4">-->
<!--            <label class="form-label">Qyteti:</label>-->
<!--            <select v-model="form.city_id" :error="form.errors.city_id"-->
<!--                    class="form-select focus:ring-0 hover:border-indigo-500"-->
<!--            >-->
<!--              <option v-for="city in selectedCities" :key="city.id" :value="city.id">{{ city.name }}</option>-->
<!--            </select>-->
<!--          </div>-->


          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="form-label">Qyteti:</label>
            <Multiselect
              v-model="form.city_id"
              :options="filterCities.options"
              :close-on-select="true"
              :searchable="true"
              :create-option="false"
              :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
            />
            <div v-if="form.errors.city_id" class="form-error">{{ form.errors.city_id }}</div>
          </div>

          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-2/4"
                      label="Adresa"
          />


          <select-input v-model="form.area_type" :error="form.errors.area_type" class="pb-8 pr-6 w-full lg:w-1/4"
                        label="Qytet/Fshat"
          >
            <option :value="null" selected>Zgjedh</option>
            <option value="qytet">Qytet</option>
            <option value="fshat">Fshat</option>
          </select-input>


          <textarea-input v-model="form.additional_info" :error="form.errors.additional_info"
                          class="pb-8 pr-6 w-full lg:w-full" label="Informata shtesë"
          />


        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Regjistro</loading-button>
          <Teleport to="body">
            <!-- use the modal component, pass in the prop -->
            <modal v-bind:show="showSuccessModal" @close="showSuccessModal = false">
              <template #header>
                <h3>Dërgesa u regjistrua me sukses.</h3>
              </template>

              <template #body><div class="flex flex-wrap"></div></template>

              <template #footer>
                <div class="flex flex-wrap">
                  <loading-button type="button" class="btn-indigo bg-red-500" @click="sendToOrders">Mbyll</loading-button>
                  <button autofocus  class="btn-indigo bg-green-600 ml-auto" type="button" @click="showSuccessModal = false" @keyup.enter.native="showSuccessModal = false">Regjistro prapë</button>
                  <a class="btn-indigo ml-auto"  target="_blank" :href="route('print.order.pdf',{order: newOrderId})" type="button">Printo</a>
                </div>
              </template>
            </modal>
          </Teleport>


        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import axios from 'axios'
import Multiselect from '@vueform/multiselect'
import Modal from '@/Shared/Modal'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    Multiselect,
    Modal
  },
  layout: Layout,
  props: {
    countries: Array,
    cities: Array,
    packageSizes: Array,
    businesses: Array,
    locations: Array,
    guessOrder: Object,
    filters: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        custom_id: null,
        business_id: this.businesses[0].id,
        location_id: null,
        package_size_id: this.packageSizes[0].id,
        fragile: false,
        openable: true,
        quantity: '1',
        product_name: null,
        product_description: null,
        product_price: null,
        name: null,
        phone: null,
        second_phone: null,
        country_id: this.countries[0].id,
        city_id: null,
        address: null,
        area_type: null,
        additional_info: null,
        is_change: false,
        is_cash: false,
        has_product: true,
        return_id: null
      }),
      guessOrderForm: this.$inertia.form({
        search: this.filters.search,
      }),
      selectedLocations: this.locations,
      // selectedCities: this.cities,
      shipping_price: null,
      filterCities: {
        options: this.cities.map(function(city){
          return {value: city.id, label: city.name}
        }),
      },
      filterBusinesses: {
        options: this.businesses.map(function(city){
          return {value: city.id, label: city.name}
        }),
      },
      showSuccessModal: false,
      newOrderId: null,
      is_change_show: true,
      is_cash_show: true,
      has_product_show: false
    }
  },
  created() {
    this.getShippingPrice()
    this.getLocations()
    this.getCities()
  },
  methods: {
    sendToOrders(){
      this.$inertia.get('/admin/dergesat')
      this.showSuccessModal = false
    },
    store() {
      let self = this
      this.form.post(route('admin.orders.store'),
        {
          preserveState: true,
          onSuccess: function(res){
            self.showSuccessModal = true
            self.newOrderId = res.props.flash.order_id
            self.form.reset('custom_id','product_name','product_description','product_price','name','phone','second_phone','address','additional_info')
          }
        })
    },
    getShippingPrice() {
      let self = this
      axios.get('/ajax/shipping-pricing', {
        params: {
          business_id: this.form.business_id,
          country_id: this.form.country_id,
          package_size_id: this.form.package_size_id,
        },
      }).then(function (result) {
        self.shipping_price = result.data.pricing.shipping_price
      })

    },
    getLocations() {
      let self = this
      self.selectedLocations = []
      axios.get('/ajax/list/locations', {
        params: {
          business_id: this.form.business_id,
        },
      }).then(function (result) {
        self.selectedLocations = result.data.locations
        self.form.location_id = result.data.locations[0].id
      })
    },
    getCities() {
      let self = this
      // self.selectedCities = []
      self.filterCities.options = []
      axios.get('/ajax/list/cities', {
        params: {
          country_id: this.form.country_id,
        },
      }).then(function (result) {
        // self.selectedCities = result.data.cities
        self.filterCities.options = result.data.cities.map(function(city){
          return {value: city.id, label: city.name}
        })
        self.form.city_id = self.guessOrder != null ? self.guessOrder.data.city_id : result.data.cities[0].id
      })
    },
  },
  watch: {
    'form.business_id'(businessId) {
      this.getLocations()
      this.getShippingPrice()
    },
    'form.country_id'(countryId) {
      this.getShippingPrice()
      this.getCities()
    },
    'form.name'(newValue) {
      this.guessOrderForm.search = newValue

      this.$inertia.get('/admin/dergesat/krijo',
        {
          search: newValue,
        },
        {
          preserveState: true,
          preserveScroll: true,
          onSuccess: () => {
            if (this.guessOrder) {
              this.form.phone = this.guessOrder.data.phone
              this.form.second_phone = this.guessOrder.data.second_phone
              this.form.country_id = this.guessOrder.data.country_id
              this.form.city_id = this.guessOrder.data.city_id
              this.form.address = this.guessOrder.data.address
              this.form.additional_info = this.guessOrder.data.additional_info
            } else {
              this.form.phone = null
              this.form.second_phone = null
              this.form.country_id = this.countries[0].id
              this.form.city_id = this.filterCities.options[0].id
              this.form.address = null
              this.form.additional_info = null
            }
          }
        }
      )
    },
    'form.package_size_id'(packageSizeId) {
      this.getShippingPrice()
    },
    'form.is_change'(newValue){
      if(newValue === true){
        this.is_cash_show = false;
        this.form.is_cash = false;
        this.form.has_product = true
        this.has_product_show = false;
      } else {
        this.is_cash_show = true;
        this.form.has_product = false;
      }
    },
    'form.is_cash'(newValue){
      if(newValue === true){
        this.has_product_show = true;
        this.is_change_show = false;
        this.form.is_change = false
      } else {
        this.form.has_product = false;
        this.is_change_show = true;
        this.form.is_change = false;
        this.has_product_show = false;
      }
    },
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
